import React from 'react';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export interface StaticMapProps {
  latitude?: number;
  longitude?: number;
  zoom?: number;
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

/**
 * Ported from Authentication76's StaticMap — non-interactive map with a
 * pin, rendered server-side by Azure Maps (see HeavyDutyMachineryApi's
 * LocationsController.StaticMap) — a single image request instead of an
 * interactive SDK's tile grid. Renders nothing if coordinates aren't
 * available yet.
 */
const StaticMap: React.FC<StaticMapProps> = ({ latitude, longitude, zoom = 14, width = 400, height = 220, style }) => {
  if (latitude == null || longitude == null) return null;

  const baseUrl = process.env.REACT_APP_HEAVY_DUTY_MACHINERY_API_URL || '';
  const src =
    `${baseUrl}${API_ENDPOINTS.HEAVY_DUTY_MACHINERY_LOCATIONS_STATIC_MAP}` +
    `?latitude=${latitude}&longitude=${longitude}&zoom=${zoom}&width=${width}&height=${height}`;

  return (
    <img
      src={src}
      alt=""
      width={width}
      height={height}
      // The `width`/`height` attributes above only size the actual image
      // requested from the server (Azure Maps renders it at exactly that
      // pixel size) -- without capping the rendered CSS width too, a
      // narrower container (e.g. the wizard's mobile column) can't shrink
      // it, so it overflows and drags the whole page into horizontal
      // scroll. `height: auto` keeps the aspect ratio once maxWidth kicks in.
      style={{ borderRadius: 8, display: 'block', maxWidth: '100%', height: 'auto', ...style }}
    />
  );
};

export default StaticMap;
